<template>
  <v-dialog @input="clearForm" v-model="app.showLoginDialog" max-width="600" class="overflow-visible" ref="loginDialog">
    <v-card class="sigfloCard overflow-visible" :loading="app.authenticating" :disabled="app.authenticating">
      <v-card-text class="pb-8 overflow-visible">
        <v-avatar color="white" class="logoAvatar" width="56" height="56">
          <img src="@/assets/images/sigfloSymbolLogo.svg" alt="Sigflo" />
        </v-avatar>
      </v-card-text>
      <v-card-text class="pt-4">
        <div class="font-weight-light text-h4 text-darken-2 d-flex">
          <v-spacer />
          Login
          <v-spacer />
        </div>
        <div v-show="error" class="text-caption red--text text-center">
          {{ error }}
        </div>
        <div class="px-12 mt-12">
          <v-text-field autofocus label="Email" v-model="email" outlined filled required></v-text-field>
          <v-text-field
            label="Password"
            v-model="password"
            outlined
            filled
            required
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
          ></v-text-field>
          <v-checkbox v-model="rememberMe" label="Remember me" class="mt-0"></v-checkbox>
          <v-btn dark color="primary" @click="login" block large>Log In</v-btn>
        </div>
        <div class="d-flex mt-4">
          <v-spacer />
          <a href="#" @click="showForgotPasswordDialog">Forgot login?</a>
          <v-spacer />
        </div>
        <div class="d-flex">
          <v-spacer />
          <div>
            Don't have an account?
            <a href="#" @click="showCreateAccountDialog">Sign up</a>
          </div>
          <v-spacer />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        error: '',
        email: '',
        password: '',
        rememberMe: false,
        showPassword: false
      };
    },
    methods: {
      /**
       * Clears the form by resetting the email, password, rememberMe, and showPassword properties.
       */
      clearForm() {
        this.email = '';
        this.password = '';
        this.rememberMe = false;
        this.showPassword = false;
      },
      /**
       * Logs in the user with the provided email and password.
       *
       * @method login
       * @memberof LoginDialog
       * @returns {void}
       */
      login() {
        var payload = {
          email: this.email,
          password: this.password,
          rememberMe: this.rememberMe
        };
        this.$store.dispatch('app/login', payload).catch(() => {
          this.error = 'Invalid Username or Password. Please try again.';
        });
      }
    },
    computed: {
      ...mapState(['app'])
    }
  };
</script>

<style>
  .v-dialog {
    overflow-y: visible !important;
  }
  .logoAvatar {
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
